module.exports = __webpack_public_path__ + "img/mb-light.e9d57d9f.png";